export const blockConstants = {
    REQUEST_GROUP: 'REQUEST_GROUP',
    REQUEST_GROUP_SUCCESS: 'REQUEST_GROUP_SUCCESS',
    REQUEST_GROUP_FAILURE: 'REQUEST_GROUP_FAILURE',
    PERSONNAL_GROUP: 'PERSONNAL_GROUP',
}
